var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity-detail"},[_vm._v(" 活动详情 ")])}
var staticRenderFns = []

export { render, staticRenderFns }